const html = require("./html/pickupSchedulingReviewView.html");
import {setElementsFromScope, insertTextAndClean, swapClassesViaBool, boolToHuman, swapClasses, insertValAndManageFocus, show, hide, handleDisplayForV2} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AsnStore from "../../../stores/AsnStore";
import {toWeekDayMonthAndDay, militaryToPeriodTime} from "../../../utilities/general";

const elementsMap = {
  pickupDate: ".pickup-date-val",
  pickupTime: ".pickup-time-val",
  insidePickup: ".inside-pickup-val",
  liftGatePickup: ".lift-gate-pickup-val",
  limitedAccess: ".limited-access-val",
  lumperPickup: ".lumper-pickup-val",
  driverLoad: ".driver-load-val",

  insidePickupMessage: ".inside-pickup-message",
  liftGatePickupMessage: ".lift-gate-pickup-message",
  limitedAccessMessage: ".limited-acess-message",
  lumperPickupMessage: ".lumper-pickup-message",
  driverLoadMessage: ".driver-load-message"
}

const yesClassName = "q-ppt-purple";
const noClassName = "q-ppt-blue-border";

export default function PickupSchedulingReviewView(_unused, {
  getAsn,
  isPallet
}){
  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
  }

  function updateSelf(){
    updateValues();
    updateClasses();
    updateMessages();
  }

  function updateValues(){
    const asn = getAsn();
    insertTextAndClean(els.pickupDate, toWeekDayMonthAndDay(asn.pickupDate));
    insertTextAndClean(els.pickupTime,  getPickupTimeRange(asn));
    insertTextAndClean(els.insidePickup, boolToHuman(asn.insidePickup));
    insertTextAndClean(els.liftGatePickup, boolToHuman(asn.liftGatePickup));
    insertTextAndClean(els.limitedAccess, boolToHuman(asn.limitedAccess));
    insertTextAndClean(els.lumperPickup, boolToHuman(asn.lumperPickup));
    insertTextAndClean(els.driverLoad, boolToHuman(asn.driverLoad));
  }

  function getPickupTimeRange(asn){
    const ptf = militaryToPeriodTime(asn.pickupTimeFrom);
    const ptt = militaryToPeriodTime(asn.pickupTimeTo);
    return `${ptf} - ${ptt}`;
  }


  function updateClasses(){
    const asn = getAsn();
    swapClassesViaBool(els.insidePickup, yesClassName, noClassName, asn.insidePickup);
    swapClassesViaBool(els.liftGatePickup, yesClassName, noClassName, asn.liftGatePickup);
    swapClassesViaBool(els.limitedAccess, yesClassName, noClassName, asn.limitedAccess);
    swapClassesViaBool(els.lumperPickup, yesClassName, noClassName, asn.lumperPickup);
    swapClassesViaBool(els.driverLoad, yesClassName, noClassName, asn.driverLoad);
  }

  function updateMessages(){
    const asn = getAsn();
    handleDisplayForV2(els.insidePickupMessage, asn.insidePickup);
    handleDisplayForV2(els.liftGatePickupMessage, asn.liftGatePickup);
    handleDisplayForV2(els.limitedAccessMessage, asn.limitedAccess);
    handleDisplayForV2(els.lumperPickupMessage, asn.lumperPickup);
    handleDisplayForV2(els.driverLoadMessage, asn.driverLoad);
  }


  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.bindListener("asns:change", updateSelf);
  }

  self.unbindListeners = function(){
    AsnStore.unbindListener("asns:shipping_method_changed", updateSelf);
    AsnStore.unbindListener("asns:change", updateSelf);
  }

  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/PickupSchedulingReviewView.js